import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { PRODUCT_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Permisos del menú Catálogo de Productos (granularidad custom).
 * Menú visible ⇒ Ver fila; el resto de acciones se asignan una a una en Gestión de roles.
 */
export function useProductCatalogPermissions() {
  const canViewMenu = usePermission(PRODUCT_PERMISSIONS.VIEW);
  const canViewRow = usePermission(PRODUCT_PERMISSIONS.VIEW_ROW);
  const canAdd = usePermission(PRODUCT_PERMISSIONS.ADD);
  const canExport = usePermission(PRODUCT_PERMISSIONS.EXPORT);
  const canDelete = usePermission(PRODUCT_PERMISSIONS.DELETE);
  const canEdit = usePermission(PRODUCT_PERMISSIONS.EDIT);
  const canDuplicate = usePermission(PRODUCT_PERMISSIONS.DUPLICATE);
  const canShowSupplierColumn = usePermission(PRODUCT_PERMISSIONS.COLUMN_SUPPLIER);

  return useMemo(
    () => ({
      canViewMenu,
      canViewRow,
      canAdd,
      canExport,
      canDelete,
      canEdit,
      canDuplicate,
      canShowSupplierColumn,
    }),
    [
      canViewMenu,
      canViewRow,
      canAdd,
      canExport,
      canDelete,
      canEdit,
      canDuplicate,
      canShowSupplierColumn,
    ],
  );
}
